import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'open_document',
    initialState: {open_documents: []},
    reducers:{
        getOpenDocuments: (state,action)=>{
            state.open_documents = action.payload
        }
    }
})

export const getAllOpenDocuments = () => apiCall({
    url: 'open-data/',
    method: 'GET',
    onSuccess: slice.actions.getOpenDocuments.type
})


export default slice.reducer